module.exports = __webpack_public_path__ + "static/industries-manufacturing-73595e000816e9158cba54f008dd5eff.png";